import ResponseModel from "../models/response.model";
import axiosSetup from "../utils/axiosSetup";

export const getEntitiesWithBOMApi = async (params: {
  page: number;
  limit: number;
  from: string;
  search?: string;
}): Promise<ResponseModel> => {
  try {
    const path = "/factory/copy-bom/entities";
    const res = await axiosSetup.get(path, { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getBOMComponentsApi = async (
  bomId: string,
  from: string,
): Promise<ResponseModel> => {
  try {
    const path = `/factory/copy-bom/get-materials/${bomId}`;
    const res = await axiosSetup.get(path, { params: { from } });
    return res.data;
  } catch (error) {
    throw error;
  }
};
